<div class="dialog">
  <div class="header">
    <button
      appButton
      name="back"
      location="share-gallery-app-dialog"
      [iconButton]="true"
      color="simple-gray"
      height="0"
      (click)="onBack()"
    >
      <app-svg src="/assets/icons/arrow-left.svg"></app-svg>
    </button>
    <h1>Mobile App</h1>
  </div>

  <div class="fake-app-container">
    <img src="/assets/icons/special/app-bg.svg" class="bg" alt="" />
    <div class="gallery-content">
      <app-editable-gallery-teaser-icon
        [gallery]="gallery()"
        shape="rounded-rectangle"
        [shadow]="true"
      ></app-editable-gallery-teaser-icon>
      <h3>{{ gallery().title || 'Gallery Title' }}</h3>
    </div>
  </div>

  <p>Sharing the app link will allow people to install this gallery as an app on their phone.</p>

  <button
    appButton
    name="copy-link"
    location="share-gallery-app-dialog"
    color="primary"
    shape="round"
    height="3"
    spacing="3"
    [center]="true"
    [share]="installLink()"
    (onCopied)="onLinkCopied()"
  >
    Copy Link
  </button>
</div>
